import { SpAlert } from '../../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(RegistrationProfile) {
        this.RegistrationProfile = RegistrationProfile;
    }

    $onInit() {
        this.genders = this.resolve.genders;
        this.maritalStates = this.resolve.maritalStates;
        this.profile = angular.copy(this.resolve.profile);
    }

    save() {
        this.RegistrationProfile
            .updateProfile({id: this.profile.id}, this.profile).$promise
            .then((profile) => this.close({$value: profile}))
            .catch((response) => {
                this.spAlert = new SpAlert('danger', response.data.message);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/basic/edit/edit.controller.js